import { toast } from "react-toastify";
import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { useLazerpay } from "lazerpay-react";

import {
  Heading,
  Container,
  PriceName,
  PriceTotal,
  PriceValue,
  CheckoutButton,
  CheeckoutContainer,
} from "./Checkout.styles";

import { getCurrencySign } from "../../utils/helpers";
import UserContext from "../../context/user/userContext";
import ProductContext from "../../context/product/productContext";

const Checkout = () => {
  const navigate = useNavigate();
  const { user } = useContext(UserContext);
  const { totalCost, totalCostAfterTax = 0 } = useContext(ProductContext);

  const handleError = response => {
    console.log(response);
    toast.error("Payment unsuccessful");
  };

  const handleSuccess = () => {
    toast.success("Payment successful");
    navigate("/order-completed");
  };

  const config = {
    publicKey: process.env.REACT_APP_PUBLIC_KEY,
    customerName: user.fullName,
    customerEmail: user.email,
    currency: user.currency,
    amount: +totalCostAfterTax,
    // reference: Date.now().toString(), //using date as unique identifier
    acceptPartialPayment: true,

    onError: response => handleError(response),
    onSuccess: response => handleSuccess(response),
    onClose: () => toast.error("Transaction Incomplete, Please try again"),
  };

  const initializePayment = useLazerpay(config);

  return (
    <Container>
      <Heading>Cart Totals</Heading>

      <CheeckoutContainer>
        <PriceTotal>
          <PriceName>Subtotal</PriceName>
          <PriceValue>{`${getCurrencySign(user.currency)}${totalCost}`}</PriceValue>
        </PriceTotal>
        <PriceTotal>
          <PriceName>Totals</PriceName>
          <PriceValue>{`${getCurrencySign(user.currency)}${totalCostAfterTax}`}</PriceValue>
        </PriceTotal>

        <CheckoutButton onClick={initializePayment}>complete payment</CheckoutButton>
      </CheeckoutContainer>
    </Container>
  );
};

export default Checkout;
